<div class="modal-header">
  <h4 class="modal-title h5" translate>Alias masking for "{{gatewaySignalsConfig.typeOfData}}"</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="gatewayAliasForm" (ngSubmit)="onSave()">
  <div class="modal-body">

    <!-- VARIABLE INFORMATION TABLE -->
    <h6 class="h6" translate>1. Prepend variable information</h6>

    <div class="mb-2">
      <button class="btn btn-outline-primary btn-sm mr-2" (click)="addString('name'); $event.preventDefault()">
        <i class="fa-solid fa-plus"></i>
        <span title="Node ID" translate>
          Name
        </span>
      </button>

      <button class="btn btn-outline-primary btn-sm mr-2" (click)="addString('datatype'); $event.preventDefault()">
        <i class="fa-solid fa-plus"></i>
        <span title="Datatype of the variable" translate>
          Datatype
        </span>
      </button>

      <button class="btn btn-outline-primary btn-sm mr-2" (click)="addString('dimension'); $event.preventDefault()">
        <i class="fa-solid fa-plus"></i>
        <span title="Dimension of the variable" translate>
          Dimension
        </span>
      </button>

      <button class="btn btn-outline-primary btn-sm mr-2" (click)="addString('description'); $event.preventDefault()">
        <i class="fa-solid fa-plus"></i>
        <span title="Description text of the variable" translate>
          Description
        </span>
      </button>
    </div>

    <!-- INPUT FIELD MASK -->
    <div class="form-group mb-3">
      <input type="text" name="mask" id="mask" formControlName="mask" class="form-control"
        [(ngModel)]="mask" (change)="updateResult()" [ngClass]="{ 'is-invalid': submitted && f.mask.errors }">
        @if (submitted && f.mask.errors) {
          <div class="invalid-feedback">
            @if (f.mask.errors.required) {
              <span translate>Mask not allowed to be empty</span>
            }
          </div>
        }
      </div>

      <!-- REGULAR EXPRESSION TABLE -->
      <div class="row align-items-center mb-2">
        <div class="col-8">
          <h6 class="h6 mb-0" translate>2. Regex settings</h6>
        </div>
        <div class="col-4 text-right">
          <button type="button" class="btn btn-sm btn-outline-primary"
            (click)="collapse.toggle()" [attr.aria-expanded]="!isSysRegexCollapsed"
            aria-controls="collapseExample">
            <span translate>Show system default</span>
          </button>
        </div>
      </div>

      <table class="table vertical-align-middle">
        <thead>
          <tr>
            <th style="width:35%" translate>Regular expression</th>
            <th style="width:15%" translate>Flags</th>
            <th style="width:35%" translate>Replacement</th>
            <th style="width:15%" class="text-right" translate>Action</th>
          </tr>
        </thead>

        <tbody>
          @for (regex of copyGatewaySignalsConfig.alias.regexlist; track regex; let id = $index) {
            <tr>
              <td>
                <div class="popover-wrapper">
                  <scitis-inline-edit-input-field [isEditable]="true"
                    [value]="regex.regexp"
                    (save)="onSaveEditableRegex($event, id, 'regexp')"
                    (edit)="setEditClass(id, 'regexp')"
                    (cancel)="onCancelEditableRegex(id)"
                    [fieldValueEditClass]="regexEditFieldClass(id, 'regexp')"
                    [ngClass]="'inline-input-align'">
                  </scitis-inline-edit-input-field>
                  @if (isDuplicateRegex(id)) {
                    <div class="text-danger" translate>Expression is already defined!</div>
                  }
                </div>
              </td>
              <td>
                <div class="popover-wrapper">
                  <scitis-inline-edit-input-field [isEditable]="true"
                    [value]="regex.flags"
                    (save)="onSaveEditableRegex($event, id, 'flags')"
                    (edit)="setEditClass(id, 'flags')"
                    (cancel)="onCancelEditableRegex(id)"
                    [fieldValueEditClass]="regexEditFieldClass(id, 'flags')">
                  </scitis-inline-edit-input-field>
                </div>
              </td>
              <td>
                <div class="popover-wrapper">
                  <scitis-inline-edit-input-field [isEditable]="true"
                    [value]="regex.replacement"
                    (save)="onSaveEditableRegex($event, id, 'replacement')"
                    (edit)="setEditClass(id, 'replacement')"
                    (cancel)="onCancelEditableRegex(id)"
                    [fieldValueEditClass]="regexEditFieldClass(id, 'replacement')">
                  </scitis-inline-edit-input-field>
                </div>
              </td>
              <td class="text-right">
                <button class="btn btn-sm btn-outline-danger" (click)="onRemoveRegex(regex)" type="button">
                  <span class="fa-solid fa-trash"></span>
                </button>
              </td>
            </tr>
          }
          <tr>
            <td>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">/</span>
                </div>
                <input class="form-control" [(ngModel)]="newRegex.regexp" name="regexp" id="regexp" formControlName="regexp"
                  type="text">
                  <div class="input-group-append">
                    <span class="input-group-text">/</span>
                  </div>
                </div>
              </td>
              <td>
                <input class="form-control" [(ngModel)]="newRegex.flags" name="flags" id="flags" formControlName="flags"
                  type="text">
                </td>
                <td>
                  <input class="form-control" [(ngModel)]="newRegex.replacement" name="replacement" id="replacement"
                    formControlName="replacement" type="text">
                  </td>
                  <td class="text-right">
                    <button class="btn btn-primary" (click)="onAddRegex()" type="button">
                      <span class="fa-solid fa-plus"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="card mb-3" #collapse="ngbCollapse" [(ngbCollapse)]="isSysRegexCollapsed">
              <div class="card-body">
                <!-- CONCLUDING SYSTEM DEFAULT REGEX TABLE -->
                <table class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th colspan="2" translate>Concluding system default regex</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><span [innerText]="nodeId"></span></td>
                      <td><span translate>Node ID</span></td>
                    </tr>
                    <tr>
                      <td><span [innerText]="variableDatatype"></span></td>
                      <td><span translate>Datatype of the variable</span></td>
                    </tr>
                    <tr>
                      <td><span [innerText]="variableDimension"></span></td>
                      <td><span translate>Dimension of the variable</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!--  VALUES TABLE -->
            <h6 class="h6" translate>3. Preview</h6>
            <div style="height: 280px; overflow: scroll">
              <table class="table table-signals table-hover">
                <thead>
                  <tr>
                    <th translate>Name</th>
                    <th translate>Alias</th>
                  </tr>
                </thead>
                <tbody>
                  @for (value of copyGatewaySignalsConfig.values; track value) {
                    <tr
                      [ngClass]="getDuplicatedClass(value)">
                      <td>
                        <ng-template #AliasTooltip>
                          <dl class="info-list">
                            <dt><span translate>Name</span>:</dt>
                            <dd [innerText]="value.name"></dd>
                            <dt><span translate>Datatype</span>:</dt>
                            <dd [innerText]="value.datatype"></dd>
                            <dt><span translate>Dimension</span>:</dt>
                            <dd [innerText]="value.dimension"></dd>
                            <dt><span translate>Description</span>:</dt>
                            <dd [innerText]="value.description"></dd>
                          </dl>
                        </ng-template>
                        <div>
                          <span [innerText]="value.name"></span>
                          <span class="ml-1 text-black-50" placement="top" [ngbTooltip]="AliasTooltip"><i
                          class="fa-solid fa-circle-info"></i></span>
                        </div>
                      </td>
                      <td [innerText]="getAliasValue(value)"></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <!-- DUPLICATED ALIASES -->
            @if (duplicatedAliasFound) {
              <div
                class="alert alert-danger">
                <i class="fa-solid fa-triangle-exclamation mr-1"></i>
                <span translate>There are duplicated aliases defined!</span>
              </div>
            }
          </div>

          <div class="modal-footer">
            <div class="modal-footer-inner">
              <div class="row align-items-center flex-fill">
                <div class="col"></div>
                <div class="col-auto">
                  <button type="button" class="btn btn-outline-primary mr-2" (click)="onCancel()">
                    <span translate>Cancel</span>
                  </button>
                  <button type="submit" class="btn btn-primary" [disabled]="isDisabledSaveBtn">
                    <span translate>Apply</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
